import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractType } from '../abstract-type';

@inheritSerialization(AbstractType)
export class ConfigurationField extends AbstractType {
  @autoserialize
  category: string;

  @autoserialize
  active: boolean;
}
